module.exports = __webpack_public_path__ + "static/media/brand-refresh-RewardsIcon.2cf23a22.svg";